import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, interval, concat } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil, take, tap } from 'rxjs/operators';
import * as UploadActions from './upload.actions';

@Injectable()
export class UploadEffects {
  private readonly _actions$ = inject(Actions);

  uploadFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(UploadActions.startUpload),
      // The `url` is received here but not used for the simulation, as requested.
      mergeMap(({ file /*, url */ }) => {
        const { id } = file;

        // Create a simulated upload stream that emits progress over a random duration (5-15s).
        const minDuration = 5000;
        const maxDuration = 15000;
        const totalDuration =
          Math.floor(Math.random() * (maxDuration - minDuration + 1)) + minDuration;
        const steps = 100;
        const updateInterval = totalDuration / steps;

        const progress$ = interval(updateInterval).pipe(
          take(steps + 1), // Emits 101 values (0 to 100)
          tap((progress) => console.log(`[Upload Simulation] File ${id} progress: ${progress}%`)),
          map((progress) => UploadActions.uploadProgress({ id, progress }))
        );

        const success$ = of(UploadActions.uploadSuccess({ id }));

        const simulatedUpload$ = concat(progress$, success$);

        return simulatedUpload$.pipe(
          takeUntil(
            this._actions$.pipe(
              ofType(UploadActions.cancelUpload),
              filter((action) => action.id === id)
            )
          ),
          catchError((error) => of(UploadActions.uploadFailure({ id, error })))
        );
      })
    )
  );
}
